/**
 * Place this in your theme's main JS file or within a <script> tag
 * at the bottom of your product template.
 */

document.addEventListener('change', function (event) {
  // 1. Target the specific variant ID input or select dropdown
  const variantInput = event.target.closest('select[name="id"], input[name="id"]');
  if (!variantInput) return; // Exit if the change wasn't on a variant selector

  const newVariantId = variantInput.value;

  // 2. Gather the main wrapper and all bundle component wrappers
  const bundleWrapper = document.querySelector('.bundle-components-wrapper');
  const bundleGroups = document.querySelectorAll('.bundle-variant-group');

  // Exit early if this product doesn't have bundle components on the page
  if (bundleGroups.length === 0 || !bundleWrapper) return;

  let hasData = false;

  // 3. Hide every bundle group by removing the active animation class
  bundleGroups.forEach((group) => {
    group.classList.remove('is-active');
  });

  // 4. Find and reveal the group matching the new variant ID
  const activeGroup = document.querySelector(
    `.bundle-variant-group[data-variant-id="${newVariantId}"]`
  );

  if (activeGroup) {
    // Add the class to trigger the CSS fadeInBundle animation
    activeGroup.classList.add('is-active');

    // Check our data attribute to see if this variant actually has components
    if (activeGroup.dataset.hasComponents === 'true') {
      hasData = true;
    }
  }

  // 5. Hide or show the entire wrapper based on data availability
  if (hasData) {
    bundleWrapper.style.display = 'block';
    // Small timeout ensures the browser paints 'display: block' before transitioning opacity
    setTimeout(() => (bundleWrapper.style.opacity = '1'), 10);
  } else {
    bundleWrapper.style.opacity = '0';
    // Wait for the 0.3s CSS opacity transition to finish before removing it from document flow
    setTimeout(() => (bundleWrapper.style.display = 'none'), 300);
  }
});
